export default [
  {
    name: "linkedIn",
    iconName: "linkedin-square",
    link: " https://www.linkedin.com/company/mind-makers-project"
  },
  {
    name: "instagram",
    iconName: "instagram",
    link: "https://www.instagram.com/mindmakersproject"
  },
  {
    name: "facebook",
    iconName: "facebook-square",
    link: "https://www.facebook.com/MindMakersProject"
  },
  {
    name: "twitter",
    iconName: "twitter-square",
    link: "https://twitter.com/mindmakersproj"
  }
]


// WEBPACK FOOTER //
// ./src/constants/social.js